export const GET_ALL_SPECIES = "GET_ALL_SPECIES";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_SPECIES = "START_LOADING_SPECIES";
export const STOP_LOADING_SPECIES = "STOP_LOADING_SPECIES";
export const ERROR_LOADING_SPECIES = "ERROR_LOADING_SPECIES";